<template>
  <div>
    <b-card >
      <b-button
      @click="support"
      variant="primary">
      <span class="mr-25 align-middle">Go To Help Guides</span>
    </b-button>
    </b-card>
  </div>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue';

export default {
  components: {
    BCard,
    BButton,
  },
  mounted() {
    window.open("http://support.vanspace3d.com/");
  },
  methods: {
    support() {
      window.open("http://support.vanspace3d.com/");
    }
  }
}
</script>

<style>

</style>
